"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Notifications {
    /**
     * @method native: Call Native notifications with the content of the options property
     */
    native(options) {
        try {
            const createNotification = new ToyotaNotification({
                action: options.action,
                body: options.body,
                comment: options.comment,
                icon: options.icon,
                icon_bg: options.icon_bg,
                link: options.link,
                type: '@native',
            });
        }
        catch (e) {
            throw Error('Missing options first need to set the options for the Notification');
        }
    }
    /**
     * @method browser: Call Browser notification
     * @param layout: Supported layout on 706 Spec for notifications
     * @param app: AppId should exist on HU AppInfo Api
     */
    browser(options) {
        try {
            if (options.pattern === '' || options.uri === '') {
                throw Error('Missing options, first need to set the options for the Notification');
            }
            const createNotification = new ToyotaNotification({
                pattern: options.pattern,
                type: '@browser',
                uri: options.uri,
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.default = Notifications;
//# sourceMappingURL=Notifications.js.map